module.exports = __webpack_public_path__ + "static/media/children.1e5e27c2.png";